/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import { Labeled } from 'react-admin';
import _get from 'lodash/get';

const DownloadAttachementLink = (props) => {
  const { source, label } = props;

  const record = useRecordContext(props);
  const href = _get(record, `${source}.url`, null);
  const title = _get(record, `${source}.title`, null);

  if (!href) return null;

  return (
    <div>
      <Labeled label={label}>
        <a href={href} download>
          {title}
        </a>
      </Labeled>
    </div>
  );
};

DownloadAttachementLink.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default DownloadAttachementLink;
